import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { RoundingDialogModule } from "@app/shared/dialogs/rounding-dialog/rounding-dialog.module";
import { EstimationStatisticsGraphModule } from "@app/shared/estimation-statistics-graph/estimation-statistics-graph.module";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { DataTableComponent } from "./data-table.component";
import { DataTableFilterDialogComponent } from "./data-table-filter-dialog/data-table-filter-dialog.component";

@NgModule({
	declarations: [DataTableComponent, DataTableFilterDialogComponent],
	imports: [
		CommonModule,
		TranslateModule,
		MaterialModule,
		DateFnsModule,
		RoundingDialogModule,
		ScrollingModule,
		EstimationStatisticsGraphModule,
	],
	exports: [DataTableComponent],
})
export class DataTableModule {}
